import React, { ReactNode, useCallback, useContext, useState } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import Collapsible from '@prisjakt/ui-collapsible';
import { useViewportContext } from '../viewport/context';

type Props = {
  children: ReactNode;
  mobile?: boolean;
  tablet?: boolean;
  desktop?: boolean;
};

function Collapsed({ children, mobile, tablet, desktop }: Props) {
  const { t } = useContext(AppContext);
  const { isMobile, isTablet, isDesktop } = useViewportContext();
  const shouldCollapse = !!(
    (isMobile && mobile) ||
    (isTablet && tablet) ||
    (isDesktop && desktop)
  );
  const [isCollapsed, setCollapsed] = useState(shouldCollapse);
  const expand = useCallback(() => setCollapsed(false), []);

  return (
    <Collapsible
      collapsed={shouldCollapse && isCollapsed}
      expandText={t('symbols', 'symbol.expand')}
      onExpand={expand}
    >
      {children}
    </Collapsible>
  );
}

export default Collapsed;
